/* eslint-disable @repo/internal/react/require-jsdoc */

import React, { type ReactNode, useContext } from 'react';

import { Banner } from '@af/design-system-docs-ui/banner';
import { PageContentContainer } from '@af/design-system-docs-ui/page-content-container';
import { Box } from '@atlaskit/primitives/box';
import { Flex } from '@atlaskit/primitives/components/flex';
import { SCREEN } from '@atlassian/analytics-bridge/constants';
import { ContextWrapper as ContextualAnalyticsData } from '@atlassian/analytics-bridge/context-wrapper';
import { FireScreenAnalytics } from '@atlassian/analytics-bridge/fire-analytics';

import MetaTags from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/meta-tags';
import { PageContext } from '../components/page-context';
import { useDwellTimeAnalytics } from '../hooks/use-dwell-time-analytics';
import { useScrollDepthAnalytics } from '../hooks/use-scroll-depth-analytics';
import { normalizeSourceName } from '../utils/analytics';
import titleify from '../utils/titleify';

type OverviewPageProps = {
	title: string;
	description: string;
	image?: {
		light: string;
		dark: string;
	};
	categorySlug: string;
	entries: Array<any>;
	tileColor?: string;
	defaultIcon?: string;
	guidelineCategory?: string;
	hasDotGrid?: boolean;
	children: ReactNode;
};

const OverviewPage = ({
	title,
	description,
	image,
	categorySlug,
	entries,
	hasDotGrid,
	children,
}: OverviewPageProps): React.JSX.Element => {
	const { contentARI } = useContext(PageContext);

	useScrollDepthAnalytics({ contentARI });
	useDwellTimeAnalytics({ contentARI });

	return (
		<ContextualAnalyticsData
			sourceType={SCREEN}
			sourceName="index"
			attributes={{
				name: `${normalizeSourceName(title)}Home`,
				entriesCount: entries.length,
				contentARI: contentARI,
			}}
		>
			<MetaTags title={title} description={description} categorySlug={titleify(categorySlug)} />
			<FireScreenAnalytics key={title} />
			<Banner title={title} description={description} image={image} hasDotGrid={hasDotGrid} />
			<Flex justifyContent="center">
				<PageContentContainer>
					<Box paddingBlock="space.800">{children}</Box>
				</PageContentContainer>
			</Flex>
		</ContextualAnalyticsData>
	);
};

export default OverviewPage;
